import wordmark from "./assets/kexu-wordmark-v3.svg";
import BrandIcon from "./BrandIcon";
import { useTranslation } from "./i18n";
import "./BrandWordmark.css";

export default function BrandWordmark() {
  const { t } = useTranslation("brand");
  return (
    <span className="brand-signature" role="img" aria-label={`${t("name")} ${t("english")}`}>
      <BrandIcon className="brand-symbol" />
      <span className="brand-wordmark" aria-hidden="true">
        <img className="brand-wordmark-art" src={wordmark} width={104} height={42} alt="" />
      </span>
    </span>
  );
}
